import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { TextField, Typography, Button } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";

import { useCallback, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import Logo from '../../../Media/Upload.jpeg';
import "../../Myaccount/Myaccount.css";

export default function PrequalificationInformation() {

    const { t } = useTranslation();

    const [photos, setPhotos] = useState([]);
    const [logos, setLogos] = useState([]);

    const validationSchema = Yup.object().shape({
        acceptVendors: Yup.string()
            .required('Accept Vendors is required !')
            .typeError('Accept Vendors is required !'),
        trainingRequired: Yup.string()
            .required('New password is required !')
            .typeError('Training Required is required !'),
        previousPrequalification: Yup.string()
            .required('Copy Answers form Previous Prequalification is required !')
            .typeError('Copy Answers form Previous Prequalification is required !'),
        provideTrainingCertificate: Yup.string()
            .required('Provide Training Certificate is required !')
            .typeError('Provide Training Certificate is required !'),
        expirationPeriod: Yup.string()
            .required('Contractor Evaluation Expiration Period is required !'),
    });
    const activeStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#ff1744'
    };
    const onDrop = useCallback(acceptedFiles => {
        setPhotos(acceptedFiles.map(photos => Object.assign(photos, {
            preview: URL.createObjectURL(photos)
        })));
    }, []);
    const onLogo = useCallback(acceptedFiles => {
        setLogos(acceptedFiles.map(logos => Object.assign(logos, {
            preview: URL.createObjectURL(logos)
        })));
    }, []);
    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({
        onDrop,
        onLogo,
        accept: 'image/jpeg, image/png'
    });

    const style = useMemo(() => ({
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);
    const thumbs = photos.map(photo => (
        <div key={photo.name}>
            {photo.name}
        </div>
    ));
    const selectlogo = logos.map(logo => (
        <div key={logo.name}>
            {logo.name}
        </div>
    ));

    useEffect(() => () => {
        photos.forEach(photo => URL.revokeObjectURL(photo.name));
    }, [photos]);
    useEffect(() => () => {
        logos.forEach(logo => URL.revokeObjectURL(logo.name));
    }, [logos]);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = (data) => {
        data.file = photos;
        console.log(data);
    };
    return (
        <>
            <div className='form'>
                <label className='personal-info-heading'><b>PrequalificationInformation</b></label>
                <Divider className='mt-3' />
                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">Contractor Evaluation Expiration Period:(Years) <small style={{ color: "red" }}>*</small> </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            select
                            id="expirationPeriod"
                            name="expirationPeriod"
                            placeholder="expirationPeriod"
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('expirationPeriod')}
                        >
                            <MenuItem value={10}>1</MenuItem>
                        </TextField>
                        <Typography className='text-danger mx-2 mt-1' component={'span'} >
                            {errors.expirationPeriod?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />
                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">Representative Name</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            type="text"
                            id="representativeName"
                            name="representativeName"
                            placeholder="Representative Name"
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('representativeName')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'} >
                            {errors.representativeName?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>
                <Divider className='mt-3' />
                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">Representative Email </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            type="email"
                            id="representativeEmail"
                            name="representativeEmail"
                            placeholder="Representative Email"
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('representativeEmail')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'} >
                            {errors.representativeEmail?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>
                <Divider className='mt-3' />
                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">InfusionSoft ContactID </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            type="text"
                            id="infusionSoftContactID "
                            name="infusionSoftContactID"
                            placeholder="InfusionSoft ContactID"
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('infusionSoftContactID')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'} >
                            {errors.infusionSoftContactID?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>
                <Divider className='mt-3' />
                <div className='row'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">Select Logo</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <div className="drop" {...getRootProps({ style })} >
                            <img className='mt-2' src={Logo} alt="" />
                            <br />
                            <input {...getInputProps()} />

                            <span className='text-muted mt-2 fs'><b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span>
                                {t('DragandDrop.firstLabel2')}</b></span>
                            <br />
                            <span className=' text-muted Fs'>
                                {t('DragandDrop.secondLabel')}</span>
                            <span className=' text-muted Fs'> {thumbs}</span>
                        </div>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>
                <Divider className='mt-3' />
                <div className='row'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Myinformation.selectphoto')}</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <div className="drop" {...getRootProps({ style })} >
                            <img className='mt-2' src={Logo} alt="" />
                            <br />
                            <input {...getInputProps()} />

                            <span className='text-muted mt-2 fs'><b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span>
                                {t('DragandDrop.firstLabel2')}</b></span>
                            <br />
                            <span className=' text-muted Fs'>
                                {t('DragandDrop.secondLabel')}</span>
                            <span className=' text-muted Fs'> {selectlogo}</span>
                        </div>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>
                <Divider className='mt-3' />
                <div className='row mt-3 mb-3'>
                    <div className='text-right'>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit(onSubmit)}>
                            {t('security.save')}
                        </Button>
                    </div>
                </div>


            </div>

        </>
    )
}